import React, { useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';

const MatnrIntegrationStatusTable = ({ 
    items, 
    lazyParams, 
    totalRecords, 
    loading, 
    onPage, 
    onSort 
}) => {
    const { th } = useLanguage();
    const dataTableRef = useRef(null);
    const columnsRef = useRef(null);

    const getColumnsCallback = useCallback((el) => {
        if (el && el.getColumns && !columnsRef.current) {
            columnsRef.current = el.getColumns();
        }
        dataTableRef.current = el;
    }, []);

   
    return (
        <DataTable
            value={items}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={th('common.noRecords')}
            rowsPerPageOptions={[10, 25, 50]}
            dataKey="matnr"
            tableStyle={{ minWidth: '60rem' }}
            showGridlines
            stripedRows
            className="p-datatable-gridlines"
            filterDisplay="menu"
            globalFilterFields={['matnr']}
            ref={getColumnsCallback}
            scrollable
            scrollHeight="flex"
        >
            <Column 
                field="matnr" 
                header={th('matnrIntegrationStatus.columns.matnr') } 
                sortable 
                style={{ minWidth: '12rem' }} 
            />
            <Column 
                field="karakteristik" 
                header={th('matnrIntegrationStatus.columns.karakteristik')} 
                sortable 
                style={{ minWidth: '10rem' }} 
            />
            <Column 
                field="eurFiyat" 
                header={th('matnrIntegrationStatus.columns.eurFiyat') } 
                sortable 
                style={{ minWidth: '8rem' }} 
            />
            <Column 
                field="cadFiyat" 
                header={th('matnrIntegrationStatus.columns.cadFiyat') } 
                sortable 
                style={{ minWidth: '8rem' }} 
            />
            <Column 
                field="tryFiyat" 
                header={th('matnrIntegrationStatus.columns.tryFiyat')} 
                sortable 
                style={{ minWidth: '8rem' }} 
            />
            <Column 
                field="stockStatus" 
                header={th('matnrIntegrationStatus.columns.stockStatus')} 
                sortable 
                style={{ minWidth: '10rem' }} 
            />
        </DataTable>
    );
};

export default MatnrIntegrationStatusTable;